module.exports = __webpack_public_path__ + "static/ocupacio-transformacio-d6fe6f04806c6eb3de8a55039006ea94.png";